import React, { useState, useEffect } from "react"
import {
  listEventsContainer,
  listEventsTitle,
  eventsContainer,
  eventsDescription,
  allEvents,
  editButtonTitle,
} from "./agenda.module.scss"
import {
  eventCalendar,
  eventCalendarHeader,
  eventCalendarDetails,
  eventDetailsCancel,
  eventCalendarDetailsTitle,
  eventCalendarDetailsCategory,
  eventCalendarDetailsDate,
  eventCalendarDetailsPlaceContainer,
  eventCalendarDetailsPlace,
  eventCalendarDetailsPlaceTitle,
  eventCalendarDetailsImage,
} from "./Calendar/event-calendar.module.scss"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { Title, ListEventsContainer } from "./agenda-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import { useAgendaEvent } from "gatsby-theme-blank/src/components/Home/Agenda/agenda-query"
import RenderEvenements from "gatsby-theme-blank/src/components/Home/Agenda/RenderEvenements/render-evenements"
import { isDateStillValid } from "gatsby-theme-blank/src/components/Home/Agenda/utils/is-date-still-valid"
import { Calendar, momentLocalizer } from "react-big-calendar"
import {
  StyledCalendar,
  EventDetailsCancel,
  SeeEvent,
  EventPlaceTitle,
} from "./Calendar/calendar-styled"
import moment from "moment"
import "react-big-calendar/lib/css/react-big-calendar.css"
import CustomToolbar from "gatsby-theme-cactus/src/gatsby-theme-blank/components/Home/Agenda/Calendar/toolbar-calendar"
import {
  CustomEvent,
  CustomEventAgenda,
} from "gatsby-theme-blank/src/components/Home/Agenda/Calendar/event-calendar"
import { EventPlaceIcon } from "../../../templates/details/styled-components/evenement-styled"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import root from "window-or-global"
import { eventPlaceIcon } from "../../../templates/details/styles/detailsEvent.module.scss"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import { Taxo } from "gatsby-theme-blank/src/components/Home/Agenda/EvenementContent/evenement-content-styled"
import "moment/locale/fr"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"
import Popup from "reactjs-popup"
import "reactjs-popup/dist/index.css"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------Parent component---------------------------//

function debounce(fn, ms) {
  let timer
  return (element) => {
    clearTimeout(timer)
    timer = setTimeout((_element) => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  }
}

const AgendaEvenements = () => {
  const data = useAgendaEvent()
  const [dimensions, setDimensions] = useState({
    height: root.innerHeight,
    width: root.innerWidth,
  })
  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      setDimensions({
        height: root.innerHeight,
        width: root.innerWidth,
      })
    }, 1)

    root.addEventListener("resize", debouncedHandleResize)

    return (_element) => {
      root.removeEventListener("resize", debouncedHandleResize)
    }
  })
  const calendarOrNot = useBuildData().theme_settings.events_calendar
  const [selectedEvent, setSelectedEvent] = useState(false)
  const date = new Date()

  const [incomingEvents, setIncomingEvents] = useState([])
  const [publishedEvents, setPublishedEvents] = useState([])

  useEffect(() => {
    const publishedData = getPublishedData(data.allNodeEvenements.edges)
    setPublishedEvents(publishedData)
    setIncomingEvents(
      publishedData
        .filter(({ node }) => {
          if (node.field_date_de_fin !== null) {
            return isDateStillValid(
              date,
              node.fields.formatted_for_compare_field_date_de_fin
            )
          }
          return isDateStillValid(
            date,
            node.fields.formatted_for_compare_field_date_de_debut
          )
        })
        .slice(0, 4)
    )
  }, [data])

  if (incomingEvents.length === 0) {
    if (publishedEvents.length === 0) {
      return null
    }
    setIncomingEvents(
      publishedEvents
        .sort(
          (date1, date2) =>
            new Date(...date2.node.fields.date_de_debut.split("/").reverse()) -
            new Date(...date1.node.fields.date_de_debut.split("/").reverse())
        )
        .slice(0, 4)
    )
  }
  const localizer = momentLocalizer(moment)
  const formattedEventsObject = publishedEvents.map(({ node }) => {
    const date_debut_compare =
      node.fields.formatted_for_compare_field_date_de_debut
    const date_fin_compare = node.fields.formatted_for_compare_field_date_de_fin
      ? node.fields.formatted_for_compare_field_date_de_fin
      : node.fields.formatted_for_compare_field_date_de_debut
    const date_debut = node.fields.formatted_field_date_de_debut
    const date_fin = node.fields.formatted_field_date_de_fin
      ? node.fields.formatted_field_date_de_fin
      : node.fields.formatted_field_date_de_debut
    return {
      title: node.title,
      start: new Date(date_debut_compare),
      end: new Date(date_fin_compare),
      allDay: false,
      resource: {
        lieu_uri: node.field_url_lieu?.uri,
        lieu: node.field_url_lieu?.title,
        date_debut: date_debut,
        date_fin: date_fin,
        url: node.path.alias,
        image: node.relationships.field_image_event,
        categories: node.relationships.field_taxonomie_thematique[0]?.name,
      },
    }
  })
  const components = {
    toolbar: (props) => <CustomToolbar {...props} />,
    event: (props) => <CustomEvent {...props} />,
    agenda: {
      event: (props) => (
        <CustomEventAgenda setSelectedEvent={setSelectedEvent} {...props} />
      ),
    },
  }
  return (
    <ListEventsContainer className={listEventsContainer}>
      <Title className={listEventsTitle}>
        <EditButton
          addedClass={editButtonTitle}
          link={
            "/taxonomy/term/" +
            data.taxonomyTermZoneDefinie.drupal_internal__tid +
            "/edit"
          }
        />
        {data.taxonomyTermZoneDefinie?.field_label || "Évènements"}
      </Title>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={eventsDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      {calendarOrNot === 1 ? (
        <StyledCalendar>
          <Calendar
            onSelectEvent={(event) => setSelectedEvent(event)}
            popup
            localizer={localizer}
            events={formattedEventsObject}
            defaultView={dimensions.width < 600 ? "day" : "month"}
            views={
              dimensions.width < 600
                ? ["day", "agenda"]
                : ["month", "week", "day", "agenda"]
            }
            components={components}
            startAccessor="start"
            endAccessor="end"
            style={dimensions.width > 600 ? { height: 800 } : { height: 600 }}
            messages={{
              showMore: (count) => `+${count}`,
              time: "Heure",
              event: "Évènement",
              allDay: "",
              noEventsInRange: "Il n'y a pas d'événement à ces dates",
            }}
          />
        </StyledCalendar>
      ) : (
        <div className={eventsContainer} role={"list"}>
          <RenderEvenements eventsData={incomingEvents} />
        </div>
      )}
      <Popup
        open={selectedEvent !== false}
        onClose={() => setSelectedEvent(false)}
        closeOnDocumentClick={true}
      >
        <div className={eventCalendar}>
          <div className={eventCalendarHeader}>
            <p>Détails de l&apos;évènement :</p>
            <EventDetailsCancel
              className={eventDetailsCancel}
              onClick={() => {
                setSelectedEvent(false)
              }}
            >
              &times;
            </EventDetailsCancel>
          </div>
          <div className={eventCalendarDetails}>
            <p className={eventCalendarDetailsTitle}>{selectedEvent.title}</p>
            <div className={eventCalendarDetailsImage}>
              {selectedEvent.resource?.image?.localFile && (
                <TransitionFade
                  arialabel={selectedEvent.title}
                  link={selectedEvent.resource?.url}
                >
                  <NonStretchedImage
                    {...selectedEvent.resource?.image?.localFile}
                    ariaHidden={true}
                  />
                </TransitionFade>
              )}
            </div>
            <Taxo className={eventCalendarDetailsCategory}>
              {selectedEvent.resource?.categories}
            </Taxo>
            {selectedEvent.resource?.date_fin ===
            selectedEvent.resource?.date_debut ? (
              <p className={eventCalendarDetailsDate}>
                Le {selectedEvent.resource?.date_debut}
              </p>
            ) : (
              <>
                <p className={eventCalendarDetailsDate}>
                  Du {selectedEvent.resource?.date_debut}
                </p>
                <p className={eventCalendarDetailsDate}>
                  Au {selectedEvent.resource?.date_fin}
                </p>
              </>
            )}
            {selectedEvent.resource?.lieu && (
              <div className={eventCalendarDetailsPlaceContainer}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className={eventCalendarDetailsPlace}
                  href={selectedEvent.resource?.lieu_uri}
                >
                  <EventPlaceIcon
                    className={eventPlaceIcon}
                    size={30}
                    icon="location2"
                  ></EventPlaceIcon>
                  <EventPlaceTitle className={eventCalendarDetailsPlaceTitle}>
                    {selectedEvent.resource?.lieu}
                  </EventPlaceTitle>
                </a>
              </div>
            )}
            <SeeEvent className="btn" link={selectedEvent.resource?.url}>
              Voir plus
            </SeeEvent>
          </div>
        </div>
      </Popup>
      <div className={allEvents}>
        <TransitionFade className="btn" link="/evenements">
          Tous les événements
        </TransitionFade>
      </div>
    </ListEventsContainer>
  )
}

//-----------------------Parent component---------------------------//

export default AgendaEvenements
